import React, {useState} from 'react'
import axios from 'axios'
import { BulkProductCalculatorView } from './BulkProductCalculatorView'
import { parseFormData } from '../../../utils/formsUtils'

export const BulkProductCalculator = () => {
    const [submitted, setSubmitted] = useState(false)
    const [output, setOutput] = useState([])
    const onSubmit = (e) => {
        e.preventDefault()
        const formData = parseFormData(e)
        const input = formData.input

        axios.post(process.env.REACT_APP_HOST + 'api/batchPricing/new', {
            params: {
                data: input
            }
        })
            .then((res) => {
                setSubmitted(true)
                setOutput(res.data)
                console.log(res.data)
            })

        
    }

    return <BulkProductCalculatorView
        onSubmit={onSubmit}
        submitted={submitted}
        output={output}
    />
}

